import { render, staticRenderFns } from "./ordercategoryprocess.vue?vue&type=template&id=71dba948&"
import script from "./ordercategoryprocess.vue?vue&type=script&lang=js&"
export * from "./ordercategoryprocess.vue?vue&type=script&lang=js&"
import style0 from "./ordercategoryprocess.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports